import { createContext, useContext, useState, useCallback } from 'react';

const ConfiguratorContext = createContext(null);

const DEFAULTS = {
  shape: 'oval',
  size: 15,
  color: 'natural',
  flavor: 'natural',
  quantity: 1,
};

export function ConfiguratorContextProvider({ children }) {
  const [state, setState] = useState(DEFAULTS);
  const [committedAt, setCommittedAt] = useState(null);

  const set = useCallback((patch) => {
    setState((prev) => ({ ...prev, ...patch }));
  }, []);

  const reset = useCallback(() => {
    setState(DEFAULTS);
    setCommittedAt(null);
  }, []);

  const commitToOrder = useCallback(() => {
    setCommittedAt(Date.now());
  }, []);

  const consumeCommittedSnapshot = useCallback(() => {
    if (committedAt === null) return null;
    const snapshot = { ...state };
    setCommittedAt(null);
    return snapshot;
  }, [committedAt, state]);

  return (
    <ConfiguratorContext.Provider
      value={{ state, set, reset, commitToOrder, committedAt, consumeCommittedSnapshot }}
    >
      {children}
    </ConfiguratorContext.Provider>
  );
}

export function useConfigurator() {
  const ctx = useContext(ConfiguratorContext);
  if (!ctx) {
    throw new Error('useConfigurator must be used within ConfiguratorContextProvider');
  }
  return ctx;
}
